/**
 * Servicio de OCR para extraer texto de imágenes de recibos/tickets.
 * Usa Tesseract.js en el cliente (sin backend).
 */
import Tesseract from "tesseract.js";
import { parseReceiptAmount, parseReceiptCurrency } from "../utils/receiptParser";

/**
 * Extrae texto de una imagen usando OCR
 * @param {File|Blob|string} imageSource - Archivo, Blob o URL de la imagen
 * @param {Function} onProgress - Callback opcional para progreso (0-100)
 * @returns {Promise<string>} Texto extraído
 */
export async function extractTextFromImage(imageSource, onProgress) {
  const result = await Tesseract.recognize(imageSource, "spa+eng", {
    logger: (m) => {
      if (onProgress && m.status === "recognizing text" && m.progress) {
        onProgress(Math.round(m.progress * 100));
      }
    }
  });
  return result.data.text;
}

/**
 * Extrae monto y moneda de un recibo desde una imagen.
 * @param {File|Blob|string} imageSource - Archivo, Blob o URL de la imagen
 * @param {Function} onProgress - Callback opcional para progreso (0-100)
 * @returns {Promise<{ amount: number | null, currency: string | null, rawText: string }>}
 */
export async function extractAmountFromReceipt(imageSource, onProgress) {
  const rawText = await extractTextFromImage(imageSource, onProgress);
  const amount = parseReceiptAmount(rawText);
  const currency = parseReceiptCurrency(rawText);
  return { amount, currency, rawText };
}
